export interface CategoryMeta {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  subs: string[];
}

export const categories: CategoryMeta[] = [
  {
    slug: 'scandal',
    name: '明星绯闻',
    desc: '聚焦明星恋情、分手、婚姻与私下同框的第一现场，追踪每一个暧昧信号。',
    icon: 'ri-heart-3-line',
    subs: ['恋情曝光', '分手传闻', '婚姻风波', '私下约会同框'],
  },
  {
    slug: 'news',
    name: '最新新闻',
    desc: '影视、综艺、音乐与商业动态一网打尽，掌握娱乐圈最新鲜的官方资讯。',
    icon: 'ri-newspaper-line',
    subs: ['影视动态', '综艺资讯', '音乐资讯', '商业代言'],
  },
  {
    slug: 'leak',
    name: '热门爆料',
    desc: '独家内幕、圈内风向与幕后花絮，来自一线爆料人的第一手消息。',
    icon: 'ri-fire-line',
    subs: ['独家爆料', '圈内风向', '幕后花絮', '网络热议'],
  },
  {
    slug: 'topic',
    name: '专题合集',
    desc: '把散落的大瓜串成线，用专题视角复盘年度八卦、塌房与豪门恩怨。',
    icon: 'ri-bookmark-3-line',
    subs: ['年度大瓜盘点', '顶流塌房合集', '豪门恩怨', '复出风云'],
  },
];

export const hotKeywords = [
  '顶流密会',
  '分手传闻',
  '古装定档',
  '奢侈代言',
  '剧组内幕',
  '小号曝光',
  '年度大瓜',
  '复出风云',
];